import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output, ViewChild, SimpleChanges } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { toJSDate } from "@ng-bootstrap/ng-bootstrap/datepicker/ngb-calendar";
import { Observable, Subject } from "rxjs";
import { takeUntil } from "rxjs/operators";
import { MaxNumberValidator } from "src/app/directives/max-number.directive";
import { PositiveNumberValidator } from "src/app/directives/positive-number.directive";
import { Divisa } from "src/app/models/Divisa";
import { DetalleDte } from "src/app/models/Dte/DetalleDte";
import { DetalleDteRentencion } from "src/app/models/Dte/DetalleDteRentencion";
import { Bulto } from "src/app/models/Dte/Exportacion/Bulto";
import { ExportacionTransporteDte } from "src/app/models/Dte/exportacionDte";
import { InvoiceType } from "src/app/models/Dte/invoiceType.enum";
import { OptionsReferenceDteEmitido } from "src/app/models/Dte/OptionsReferenceDteEmitido";
import { OtraMoneda } from "src/app/models/Dte/OtraMoneda";
import { Retencion } from "src/app/models/Dte/Retencion";
import { Impuesto } from "src/app/models/Impuesto";
import { Producto } from "src/app/models/Producto/Producto";
import { FacturacionIndividualService } from "src/app/services/facturacion-individual.service";
import { ImpuestoService } from "src/app/services/impuesto.service";
import { LocalStorageService } from "src/app/services/local-storage.service";
import { TokenStorageService } from "src/app/services/token-storage.service";
import { environment } from "src/environments/environment";
import Swal from "sweetalert2";
import { DetalleDteImpuestoAdicional } from "../../../../models/Dte/DetalleDteImpuestoAdicional";
import { CodigoItem } from "src/app/models/Dte/CodigoItem";

@Component({
	selector: "[app-item-detalle-dte]",
	templateUrl: "./item-detalle-dte.component.html",
	styleUrls: ["./item-detalle-dte.component.scss"],
})
export class ItemDetalleDteComponent implements OnInit {
	@Input() detalleDte: DetalleDte = new DetalleDte();
	@Input() detalleNumero: number = 0;
	@Input() hideExentoColumn: boolean = false;
	public clpHelperDetalle: DetalleDte = new DetalleDte();
	@Output() deleteDetalle: EventEmitter<any> = new EventEmitter<any>();
	@ViewChild("localDetalleForm") detailForm;
	public detalleFormGroup: FormGroup;
	public otraMoneda: OtraMoneda = new OtraMoneda();
	public opciones: OptionsReferenceDteEmitido = new OptionsReferenceDteEmitido();
	private opcionesObservable$: Observable<OptionsReferenceDteEmitido>;
	private divisasObservable$: Observable<Divisa[]>;
	public divisaMessage: string = "Ingresar precio en base a la moneda seleccionada";
	@Input() disableDetailFields: boolean = false;
	private divisasList: Divisa[] = [];
	private currentEmisorId = this.tokenService.getCompany();
	subPrice: number = 0;
	subtotalForeign: number = 0; //used for holding the product of form values in foreing currency
	totalForeign: number = 0;
	totalCurrency: number = 0;
	subDiscount: number = 0;
	subRecharge: number = 0;
	public montoTotalImpuestosEspecificos: number = 0;

	public porcentajeIva: number = environment.taxPercentage;
	public searchCatalog: Producto[] = [];
	public searchLoading: boolean = false;
	public currentProduct: Producto = new Producto();
	private invoiceType$: Observable<InvoiceType>;
	public showingDetails: boolean = true;
	public workWithProduct: boolean = false;
	public currentInvoiceType: InvoiceType = InvoiceType.Factura;
	public InvoiceType = InvoiceType;
	public showRetencionPercent: boolean = false;
	public retencionesSource: Retencion[] = JSON.parse(this.localStorage.getTiposRetenciones()) as Retencion[];
	public selectedRetencion: Retencion = null;

	public isExentoChecked: boolean = false;
	public lockExento: boolean = undefined;
	public showInExport: boolean = false;
	private exportDataObservable$: Observable<ExportacionTransporteDte>;
	public exportPackages: Bulto[] = [];
	private destroySubscriptions$: Subject<boolean> = new Subject<boolean>();
	public showSelect: boolean = false;
	public taxesSource: Impuesto[] = JSON.parse(this.localStorage.getImpuestos() || "[]") as Impuesto[];
	public get selectedTaxes(): Impuesto[] {
		return this.taxesSource.filter((t) => t.selected);
	}
	public getTaxTooltipMessage(): string {
		if (this.isExentoChecked) {
			return "No se puede agregar impuestos a un producto exento.";
		}
		return "";
	}
	public getExentoTooltipMessage(): string {
		if (this.currentProduct?.impuestos?.length > 0 || this.selectedTaxes.length > 0) {
			return "No se puede marcar como exento un producto con impuestos.";
		}
		return "";
	}

	public get isExentoDisabled(): boolean {
		return this.currentProduct?.impuestos?.length > 0 || this.selectedTaxes.length > 0;
	}

	public get isTaxButtonDisabled(): boolean {
		return this.isExentoChecked;
	}

	constructor(
		private builder: FormBuilder,
		private facturador: FacturacionIndividualService,
		private ref: ChangeDetectorRef,
		private tokenService: TokenStorageService,
		private impuestoService: ImpuestoService,

		private modalService: NgbModal,
		private localStorage: LocalStorageService
	) {
		this.opcionesObservable$ = this.facturador.opcionesReferenciaObservable;
		this.divisasObservable$ = this.facturador.divisasListObservable;
		this.invoiceType$ = this.facturador.currentInvoiceTypeObservable;
		this.exportDataObservable$ = this.facturador.exportacionTransporteObservable;
	}

	ngOnInit(): void {
		this.detalleDteForm();
		this.taxesSource = this.taxesSource.map((tax) => ({
			...tax,
			selected: false,
		}));
		if (this.detalleDte.dteId || (this.tieneDetalleCompleto() && (!this.detalleDte?.relatedProductId || !this.detalleDte?.relatedProduct?.productoId))) {
			this.detalleDteToForm();
		}
		this.opcionesObservable$.subscribe((opciones) => {
			this.opciones = opciones;
			this.onSubmit();
		});
		this.divisasObservable$.subscribe((divisas) => {
			this.divisasList = divisas;
			this.onSubmit();
		});
		this.invoiceType$.subscribe((res) => {
			this.modificationsByInvoiceType(res);
		});
		this.exportDataObservable$.pipe(takeUntil(this.destroySubscriptions$)).subscribe((exportResult) => {
			this.exportPackages = exportResult.listaBultos && exportResult.listaBultos.length ? [...exportResult.listaBultos] : [];
			this.ref.detectChanges();
		});
	}
	public adicionalesAbiertos = false;
	deleteItem() {
		this.deleteDetalle.emit();
	}

	private tieneDetalleCompleto(): boolean {
		return !!(this.detalleDte && this.detalleDte.nombre && this.detalleDte.cantidad > 0 && this.detalleDte.precioUnitario > 0);
	}

	checkFormSubmitted() {
		this.detailForm.nativeElement.submit();
	}

	private assignCodigoItem(tipo?: string, valor?: string) {
		if (!this.detalleDte.CodigosItem || this.detalleDte.CodigosItem.length === 0) {
			this.detalleDte.CodigosItem = [new CodigoItem()];
		}
		const item = this.detalleDte.CodigosItem[0];
		let tipoToAssign = tipo && String(tipo).trim() !== "" ? tipo : undefined;
		if (!tipoToAssign) {
			const control = this.detalleFormGroup && this.detalleFormGroup.get("tpoCodigo");
			const raw = control && control.value != null ? String(control.value).trim() : "";
			tipoToAssign = raw && raw !== "" ? raw : "INT1";
		}
		item.tipoCodigo = tipoToAssign;
		if (valor !== undefined && valor !== null) {
			item.valorCodigo = valor;
		}
	}

	detalleDteForm() {
		//colocar cantidad precio unitario y descuento en solo lectura y en 0, y si tienen valor asignado quitarselo
		this.detalleFormGroup = this.builder.group(
			{
				codigo: [this.detalleDte && this.detalleDte.codigoInterno ? this.detalleDte.codigoInterno : "", { updateOn: "blur" }],
				descripcion: [this.detalleDte && this.detalleDte.descripcion && this.detalleDte.nombre ? this.detalleDte.descripcion : ""],
				cantidad: [this.detalleDte.cantidad ? this.detalleDte.cantidad : 1, [Validators.required, PositiveNumberValidator]],
				unidadMedida: [this.detalleDte && this.detalleDte.unidadMedida ? this.detalleDte.unidadMedida : ""],
				precioUnitario: [this.detalleDte.precioUnitario ? this.detalleDte.precioUnitario : undefined, [Validators.required, PositiveNumberValidator]],
				rebajaAvaluo: [this.detalleDte.rebajaAvaluo ?? 0, [Validators.min(0)]],
				// descuento:["",[PositiveNumberValidator]],
				// recargo:["",[PositiveNumberValidator]],
				descuentoRecargo: [this.detalleDte.descuento > 0 ? this.detalleDte.descuento * -1 : this.detalleDte.recargo > 0 ? this.detalleDte.recargo : 0],
				exento: [this.lockExento],
				subtotal: [""],
				haveCodigo: [false],
				nombreItem: [this.detalleDte.nombre ? this.detalleDte.nombre : this.detalleDte.descripcion ? this.detalleDte.descripcion : "", { validators: Validators.required }],
				tpoCodigo: ["", [Validators.maxLength(10)]],
				vlrCodigo: ["", [Validators.maxLength(35)]],
				haveRetencion: [false],
				retencionPorcentaje: [19, [MaxNumberValidator(100)]],
				retencionTipo: [],
			},
			{ updateOn: "blur" }
		);
		this.detalleFormGroup.get("rebajaAvaluo")?.valueChanges.subscribe((value) => {
			if (value === null || value === "") {
				this.detalleFormGroup.get("rebajaAvaluo")?.setValue(0, { emitEvent: false });
			}
		});
		this.adicionalesAbiertos = !!(this.detalleDte.descripcion?.trim() || this.detalleDte.descuento || this.detalleDte.recargo || this.detalleDte.rebajaAvaluo);
		if (this.detalleDte.relatedProduct?.productoId) {
        	this.selectedProductToForm(this.detalleDte.relatedProduct);
    	}
	}

	openTaxModal(content: any) {
		this.modalService.open(content, { size: "lg" });
	}

	getTaxTooltip(): string {
		let selected;

		if (this.currentProduct && this.currentProduct.impuestos) {
			selected = this.taxesSource.filter((tax) => tax.selected && !this.currentProduct.impuestos.some((impuesto) => impuesto.nombre === tax.nombre)).map((tax) => ` • ${tax.nombre}: ${tax.valor}% \n`);
		} else {
			selected = this.taxesSource.filter((tax) => tax.selected).map((tax) => ` • ${tax.nombre}: ${tax.valor}% \n`);
		}

		return selected.length > 0 ? selected.join(", ") : "";
	}

	isTaxSelected(): boolean {
		let maxTaxes = 2;
		return this.taxesSource.filter((tax) => tax.selected).length >= maxTaxes;
	}
	applyTaxChanges(): void {
		this.calcularImpuestosAdicionalesEspecificos();
		this.onSubmit();
	}
	calcularImpuestosAdicionalesEspecificos(): void {
		const impuestosSeleccionados = this.taxesSource.filter((tax) => tax.selected).slice(0, 2);
		const cantidad = this.detalleFormGroup.get("cantidad")?.value || 1;
		const precioUnitario = this.detalleFormGroup.get("precioUnitario")?.value || 0;
		if (impuestosSeleccionados.length === 0) {
			this.detalleDte.impuestosAdicionales = [];
			this.detalleDte.totalImpuestosAdicionales = 0;
			return;
		}

		this.detalleDte.impuestosAdicionales = impuestosSeleccionados.map((impuesto, index) => {
			const impAdicional = new DetalleDteImpuestoAdicional();
			impAdicional.codigoSii = impuesto.tipoImpuesto;
			impAdicional.nombreImp = impuesto.nombre;
			impAdicional.tasa = impuesto.valor;
			impAdicional.valor = Math.round((impuesto.valor / 100) * (cantidad * precioUnitario));
			impAdicional.nroImp = index + 1;
			impAdicional.impuestoIdRelated = impuesto.impuestoId;
			return impAdicional;
		});

		this.detalleDte.totalImpuestosAdicionales = this.detalleDte.impuestosAdicionales.reduce((acum, imp) => acum + imp.valor, 0);

		this.montoTotalImpuestosEspecificos = this.detalleDte.totalImpuestosAdicionales;
	}

	selectImpuestoTrue(tax: Impuesto): boolean {
		return this.currentProduct?.impuestos?.some((impuesto) => impuesto.nombre === tax.nombre);
	}
	onSubmit() {
		this.ref.detectChanges();
		if (this.detalleFormGroup.valid) {
			this.detalleDte.codigoInterno = this.detalleFormGroup.controls.codigo.value;
			if (this.detalleFormGroup.controls.codigo.value) {
				if (this.detalleDte.CodigosItem.length === 0) {
					this.detalleDte.CodigosItem.push(new CodigoItem());
				}
				this.assignCodigoItem(undefined, this.detalleFormGroup.controls.codigo.value);
			}
			this.detalleDte.descripcion = this.detalleFormGroup.controls.descripcion.value?.trim() || null;

			if (this.currentProduct && this.currentProduct.impuestos) {
				this.currentProduct.impuestos.forEach((impuesto) => {
					const tax = this.taxesSource.find((t) => t.nombre === impuesto.nombre);
					if (tax) {
						tax.selected = true;
					}
				});
			}

			if (this.detalleFormGroup.controls.vlrCodigo.value != "") {
				this.assignCodigoItem(undefined, this.detalleFormGroup.controls.vlrCodigo.value);
			}
			//Limpiar codigo si ambos campos estan vacios
			const codigoCtrl = this.detalleFormGroup.controls.codigo.value;
			const vlrCtrl = this.detalleFormGroup.controls.vlrCodigo.value;
			if ((!codigoCtrl || String(codigoCtrl).trim() === "") && (!vlrCtrl || String(vlrCtrl).trim() === "")) {
				if (this.detalleDte.CodigosItem && this.detalleDte.CodigosItem.length > 0) {
					this.detalleDte.CodigosItem[0].tipoCodigo = undefined;
					this.detalleDte.CodigosItem[0].valorCodigo = undefined;
				}
			}

			this.detalleDte.nombre = this.detalleFormGroup.controls.nombreItem.value;
			this.detalleDte.cantidad = this.detalleFormGroup.controls.cantidad.value;
			this.detalleDte.unidadMedida = this.detalleFormGroup.controls.unidadMedida.value?.trim() || null;
			this.detalleDte.esExento = this.currentInvoiceType == InvoiceType.FacturaExportacion ? true : this.detalleFormGroup.controls.exento.value != undefined ? this.detalleFormGroup.controls.exento.value : false;
			// El campo debe publicarse también en moneda extranjera, incluso sin rebaja.
			this.detalleDte.rebajaAvaluo = this.detalleFormGroup.controls.rebajaAvaluo.value ?? 0;
			if (this.opciones.tipoMoneda == "CLP") {
				this.ref.detectChanges();
				this.detalleDte.precioUnitario = this.detalleFormGroup.controls.precioUnitario.value;
				this.detalleDte.descuento = this.detalleFormGroup.controls.descuentoRecargo.value < 0 ? this.detalleFormGroup.controls.descuentoRecargo.value * -1 : 0;
				this.detalleDte.recargo = this.detalleFormGroup.controls.descuentoRecargo.value > 0 ? this.detalleFormGroup.controls.descuentoRecargo.value : 0;
				//this.detalleDte.calcSubTotal();
				this.detalleDte.subtotal = this.detalleDte.cantidad * this.detalleDte.precioUnitario;
				let subMasCargos = this.detalleDte.recargo ? this.detalleDte.subtotal + this.detalleDte.recargo : this.detalleDte.subtotal;
				this.detalleDte.total = this.detalleDte.descuento ? subMasCargos - this.detalleDte.descuento : subMasCargos;
				this.ref.detectChanges();
			}
			if (this.opciones.tipoMoneda != "CLP") {
				//let tipoCambio = this.divisasList.find(divisa => divisa.nombre.toUpperCase() == this.opciones.tipoMoneda)
				let tipoCambio = this.opciones.valorTipoMoneda;

				let currentPrice = this.detalleFormGroup.controls.precioUnitario.value; //foreign currency
				let currentDiscount = this.detalleFormGroup.controls.descuentoRecargo.value < 0 ? this.detalleFormGroup.controls.descuentoRecargo.value * -1 : 0; //foreign currency
				let currentRecharge = this.detalleFormGroup.controls.descuentoRecargo.value > 0 ? this.detalleFormGroup.controls.descuentoRecargo.value : 0; //foreign currency

				this.subtotalForeign = currentPrice * this.detalleDte.cantidad; //foreign currency
				let subMasCargosForeign = currentRecharge ? currentRecharge + this.subtotalForeign : this.subtotalForeign;
				this.totalForeign = currentDiscount ? subMasCargosForeign - currentDiscount : subMasCargosForeign;

				this.subPrice = currentPrice * tipoCambio;
				this.detalleDte.precioUnitario = this.subPrice;
				this.subDiscount = Math.round((currentDiscount || 0) * tipoCambio);
				this.detalleDte.descuento = this.subDiscount;
				this.subRecharge = Math.round((currentRecharge || 0) * tipoCambio);
				this.detalleDte.recargo = this.subRecharge;
				this.detalleDte.subtotal = Math.round(+(this.detalleDte.cantidad * this.subPrice));
				let subMasCargos = this.subRecharge ? this.subRecharge + this.detalleDte.subtotal : this.detalleDte.subtotal;
				// this.detalleDte.descripcion +=
				//   " " +
				//   this.opciones.tipoMoneda +
				//   " " +
				//   currentPrice +
				//   " T/C " +
				//   tipoCambio;
				this.ref.detectChanges();

				//maintain original values in case of export invoice
				this.detalleDte.originalValuePrice = currentPrice;
				this.detalleDte.originalDiscount = currentDiscount;
				this.detalleDte.originalRecharge = currentRecharge;
				this.detalleDte.originalSubtotal = this.subtotalForeign;
				this.detalleDte.originalTotal = this.totalForeign;

				this.detalleDte.total = this.subDiscount ? subMasCargos - this.detalleDte.descuento : subMasCargos;
			}

			this.refreshImpuestoAdicionalInDetalle();
			this.detalleDte.totalImpuestosAdicionales = this.calculateTaxesInItem();
			this.detalleDte.porcentajeRetencion = this.detalleFormGroup.controls.retencionPorcentaje.value;
			if (this.detalleDte.porcentajeRetencion && this.detalleDte.porcentajeRetencion > 0 && this.selectedRetencion) {
				this.detalleDte.retenciones = [];
				let retencion = new DetalleDteRentencion();
				retencion.nombreRetencion = this.selectedRetencion.nombre;
				retencion.codigoSii = this.selectedRetencion.codigoSii;
				retencion.valor = this.detalleFormGroup.controls.retencionPorcentaje.value;
				this.detalleDte.retenciones.push(retencion);
			}
			else {
				this.detalleDte.retenciones = [];
				let retencion = new DetalleDteRentencion();
				retencion.nombreRetencion = this.detalleFormGroup.controls.retencionTipo.value;
				retencion.valor = this.detalleFormGroup.controls.retencionPorcentaje.value;
				this.detalleDte.retenciones.push(retencion);        
			}
			//calcular el total de impuestos
			this.facturador.updateItem(this.detalleDte);
			
		}
	}
	onExentoChange(event) {
		if (this.currentProduct?.impuestos?.length > 0 || this.selectedTaxes.length > 0) {
			this.detalleFormGroup.controls.exento.patchValue(false);
			this.isExentoChecked = false;
		} else {
			this.detalleFormGroup.controls.exento.patchValue(event.target.checked);
			this.isExentoChecked = event.target.checked;
		}
		this.onSubmit();
	}

	detalleDteToForm() {
		if (this.detalleDte.relatedProduct) {
			this.currentProduct = this.detalleDte.relatedProduct;
		}
		if (this.detalleDte.impuestosAsociados && this.detalleDte.impuestosAsociados.length > 0) {
			this.currentProduct.impuestos = [...this.detalleDte.impuestosAsociados];
		}
		// if(this.detalleDte.totalImpuestosAdicionales && this.detalleDte.totalImpuestosAdicionales>0){

		// }
		this.refreshImpuestoAdicionalInDetalle();
		let prod = new Producto();
		prod.nombre = this.detalleDte.nombre ? this.detalleDte.nombre : this.detalleDte.descripcion;
		this.searchCatalog.push(prod);
		this.detalleFormGroup.controls.nombreItem.patchValue(prod.nombre);
		this.detalleFormGroup.controls.codigo.setValidators([]);
		this.detalleFormGroup.controls.descripcion.patchValue(this.detalleDte.descripcion);
		this.detalleFormGroup.controls.cantidad.patchValue(this.detalleDte.cantidad);
		this.detalleFormGroup.controls.precioUnitario.patchValue(this.detalleDte.precioUnitario);
		this.detalleFormGroup.controls.subtotal.patchValue(this.detalleDte.total);
		this.detalleFormGroup.controls.exento.patchValue(this.detalleDte.esExento);
		this.ref.detectChanges();
	}

	getRetencionChanges($event: Retencion) {
		if (this.currentInvoiceType == InvoiceType.FacturaCompra) {
			this.selectedRetencion = $event; // Almacenar la retención completa
			this.detalleDte.retenciones = [];
			let retencion = new DetalleDteRentencion();
			let selectedRetencion: Retencion = $event;
			retencion.codigoSii = selectedRetencion.codigoSii;
			retencion.valor = selectedRetencion.tasaDefecto;
			retencion.nombreRetencion = selectedRetencion.nombre;
			this.detalleFormGroup.controls.retencionPorcentaje.patchValue(retencion.valor);
			this.detalleDte.retenciones.push(retencion);
		}
		this.onSubmit();
	}
	exchangeBasedCalculation() {
		//work with de selected rate of exchange to CLP and show the values under the input tags
		if (this.opciones.tipoMoneda && this.opciones.tipoMoneda != "") {
		}
	}

	changeHaveCodigo(event) {
		this.ref.detectChanges();
		this.detalleFormGroup.controls.haveCodigo.patchValue(event.target.checked);
	}

	searchItem(event, propertyName) {
		this.searchLoading = true;
		this.workWithProduct = false;
		this.facturador.searchProducts(propertyName, event.term, this.currentEmisorId).subscribe(
			(res) => {
				this.searchCatalog = [...res.data] as Producto[];
				this.ref.detectChanges();
				this.searchLoading = false;
			},
			(error) => {
				this.searchLoading = false;
				this.ref.detectChanges();
				Swal.fire({
					icon: "error",
					title: "Error en productos",
					text: "No fue posible obtener los productos concidentes con el termino buscado",
				});
			}
		);
	}
	refreshItemDetail(event: Producto) {
		//set selected item to form
		this.currentProduct = event;
		if (event && event.productoId) {
			this.getTaxesOfProduct(event);
			//this.selectedProductToForm(this.currentProduct);
		}
		//this.onSubmit();
	}

	setDetailFromPackage(event: Bulto) {
		let extraDescriptionMessage = "";
		if (event) {
			extraDescriptionMessage += event.nombreTipoBulto ? "Se incluye dentro del paquete " + event.nombreTipoBulto + " " : "";
			extraDescriptionMessage += event.marcas ? " con marca " + event.marcas : "";
			extraDescriptionMessage += event.idContainer ? " y dentro del container Id " + event.idContainer : "";
		}
		this.detalleFormGroup.get("descripcion").patchValue(extraDescriptionMessage);
		this.detalleDte.descripcion = extraDescriptionMessage;
	}

	AddProductByName = (prod: string) => {
		this.detalleFormGroup.get("nombreItem").patchValue(prod);
		if (!this.detalleFormGroup.get("codigo").value || this.detalleFormGroup.get("codigo").value == "") {
			Swal.fire({
				icon: "question",
				title: "¿Agregar nuevo producto?",
				text: 'Para agregar el nuevo producto de nombre "' + prod + '", ingrese además un código de producto en el Selector de producto por Código y presione la opción de "Agregar Producto" en la pestaña de dicho selector. Este producto será agregado si la transacción se realiza con éxito. En caso contrario, realice una nueva búsqueda y seleccione un producto existente.',
			});
			return;
		}
		this.detalleDte.nombre = prod;
		//this.detalleDte.codigoInterno = "";
		this.detalleDte.codigoInterno = this.detalleFormGroup.get("codigo").value;
		if (this.detalleFormGroup.get("codigo").value) {
			if (this.detalleDte.CodigosItem.length === 0) {
				this.detalleDte.CodigosItem.push(new CodigoItem());
			}
			this.assignCodigoItem(undefined, this.detalleFormGroup.get("codigo").value);
		}
		this.detalleDte.nombre = this.detalleFormGroup.get("nombreItem").value;
		this.detalleDte.esExento = this.currentInvoiceType == InvoiceType.FacturaExportacion ? true : this.detalleFormGroup.controls.exento.value;
		this.detalleDte.createCurrentProduct = true;
		this.workWithProduct = null;
	};

	AddProductByCode = (code: string) => {
		this.detalleFormGroup.get("codigo").patchValue(code);
		if (!this.detalleFormGroup.get("nombreItem").value || this.detalleFormGroup.get("nombreItem").value == "") {
			Swal.fire({
				icon: "question",
				title: "¿Agregar nuevo producto?",
				text: 'Para agregar el nuevo producto de código "' + code + '", ingrese además un nombre nuevo para el producto en el Selector de producto por Nombre y presione la opción de "Agregar Producto" en la pestaña de dicho selector. Este producto será agregado si la transacción se realiza con éxito. En caso contrario, realice una nueva búsqueda y seleccione un producto existente.',
			});
			return;
		}
		this.detalleDte.codigoInterno = code;
		if (code) {
			if (this.detalleDte.CodigosItem.length === 0) {
				this.detalleDte.CodigosItem.push(new CodigoItem());
			}
			this.assignCodigoItem(undefined, code);
		}
		this.detalleDte.nombre = this.detalleFormGroup.get("nombreItem").value;
		this.detalleDte.esExento = this.currentInvoiceType == InvoiceType.FacturaExportacion ? true : this.detalleFormGroup.controls.exento.value;
		this.detalleDte.createCurrentProduct = true;
		this.workWithProduct = null;
	};

	selectedProductToForm(selectedProduct: Producto) {
		if (selectedProduct) {
			if (this.detalleDte.relatedProduct) {
				this.currentProduct = { ...this.detalleDte.relatedProduct };
			}
			if (this.detalleDte.impuestosAsociados.length > 0) {
				this.currentProduct.impuestos = [...this.detalleDte.impuestosAsociados];
			}
			this.detalleFormGroup.controls.codigo.patchValue(selectedProduct.codigoBarra);
			if (selectedProduct.codigoBarra) {
				if (this.detalleDte.CodigosItem.length === 0) {
					this.detalleDte.CodigosItem.push(new CodigoItem());
				}
				this.assignCodigoItem(undefined, selectedProduct.codigoBarra);
			}
			this.detalleFormGroup.controls.precioUnitario.patchValue(selectedProduct.precio);
			let ExentoValue = this.currentInvoiceType == InvoiceType.FacturaExportacion ? true : selectedProduct.exento;
			this.detalleFormGroup.controls.exento.patchValue(ExentoValue);
			this.detalleFormGroup.controls.nombreItem.patchValue(selectedProduct.nombre);
			this.detalleDte.createCurrentProduct = false;
			if (selectedProduct.impuestos != undefined) {
				let detalleDteImpuestoAdicionalList: DetalleDteImpuestoAdicional[] = [];
				let impuestoFromProduct = [...selectedProduct.impuestos];
				impuestoFromProduct = [...impuestoFromProduct];
				detalleDteImpuestoAdicionalList = selectedProduct.impuestos.map((i) => {
					let impuestoAdicional = new DetalleDteImpuestoAdicional();
					impuestoAdicional.codigoSii = i.tipoImpuesto;
					impuestoAdicional.nombreImp = i.nombre;
					impuestoAdicional.valor = Math.round((i.valor / 100) * this.detalleDte.total);
					impuestoAdicional.nroImp = selectedProduct.impuestos.indexOf(i) + 1;
					impuestoAdicional.tasa = i.valor;
					impuestoAdicional.impuestoIdRelated = i.impuestoId;
					return impuestoAdicional;
				});
				this.detalleDte.impuestosAdicionales = [...detalleDteImpuestoAdicionalList];
				this.detalleDte.impuestosAdicionales = [...this.detalleDte.impuestosAdicionales];
			} else {
				this.detalleDte.impuestosAdicionales = [];
			}
			if (selectedProduct.unidadMedida != undefined && selectedProduct.unidadMedida != "") {
				this.detalleFormGroup.controls.unidadMedida.patchValue(selectedProduct.unidadMedida);
			}
		}
	}

	refreshImpuestoAdicionalInDetalle() {
		if (!this.currentProduct || !Array.isArray(this.currentProduct.impuestos)) {
			return;
		}
		if (this.detalleDte.impuestosAdicionales && this.detalleDte.impuestosAdicionales.length > 0) {
			this.detalleDte.impuestosAdicionales.forEach((impuestoAdicional) => {
				let relatedImpuestoInProduct = this.currentProduct.impuestos.find((impuesto) => impuesto.impuestoId == impuestoAdicional.impuestoIdRelated);
				if (!relatedImpuestoInProduct) {
					return;
				}
				let valueTax: number = 0;
				if (this.opciones.tipoMoneda != "CLP") {
					valueTax = (relatedImpuestoInProduct.valor / 100) * (this.detalleDte.total / this.opciones.valorTipoMoneda);
				} else {
					valueTax = (relatedImpuestoInProduct.valor / 100) * this.detalleDte.total;
				}
				impuestoAdicional.valor = +valueTax.toFixed(2);
				if (Array.isArray(this.detalleDte.relatedProduct.impuestos) && this.detalleDte.relatedProduct.impuestos.length > 0) {
					const nuevosImpuestos = this.taxesSource.filter((t) => t.selected);
					this.detalleDte.relatedProduct.impuestos = this.detalleDte.relatedProduct.impuestos.filter((imp) => nuevosImpuestos.some((nImp) => nImp.impuestoId === imp.impuestoId));
					nuevosImpuestos.forEach((imp) => {
						const existe = this.detalleDte.relatedProduct.impuestos.some((i) => i.impuestoId === imp.impuestoId);
						if (!existe) {
							this.detalleDte.relatedProduct.impuestos.push(imp);
						}
					});
				}
			});
		}
	}

	modificationsByInvoiceType(type: InvoiceType) {
		this.currentInvoiceType = type;
		switch (type) {
			case InvoiceType.Boleta: {
				this.showingDetails = true;
				break;
			}
			case InvoiceType.Factura: {
				this.showingDetails = true;
				break;
			}
			case InvoiceType.GuiaDespacho: {
				this.showingDetails = true;
				break;
			}
			case InvoiceType.FacturaExportacion: {
				this.lockExento = true;
				this.detalleFormGroup.controls.exento.patchValue(true);
				this.showInExport = true;
				this.onSubmit();
				break;
			}
		}
	}

	calculateTaxesInItem() {
		let taxAmount = 0;
		if (this.detalleDte.impuestosAdicionales != undefined) {
			taxAmount = this.detalleDte.impuestosAdicionales.reduce((acc, curr) => acc + curr.valor, 0);
		}
		//if item already has TOtalImpuestos adicionales from Guide Items to new Invoice
		if (this.detalleDte.totalImpuestosAdicionales && this.detalleDte.totalImpuestosAdicionales > 0) {
			taxAmount = this.detalleDte.totalImpuestosAdicionales;
		}
		return taxAmount;
	}

	getTaxesOfProduct(prod: Producto) {
		this.impuestoService.taxesByProduct(prod).subscribe(
			(res) => {
				if (this.currentProduct) {
					this.currentProduct.impuestos = res.data as Impuesto[];
					this.detalleDte.relatedProduct = prod;
					this.selectedProductToForm(this.currentProduct);
					this.ref.detectChanges();
					this.onSubmit();
				}
			},
			(error) => {
				Swal.fire({
					icon: "error",
					title: "Error en impuestos",
					text: "No fue posible obtener los impuestos del producto seleccionado",
				});
			}
		);
	}

	changeRetencionInput($event) {
		this.ref.detectChanges();
		this.detalleFormGroup.controls.haveRetencion.patchValue($event.target.checked);
		this.showRetencionPercent = this.detalleFormGroup.controls.haveRetencion.value;
	}

	ngOnDestroy() {
		this.destroySubscriptions$.next(true);
		this.destroySubscriptions$.unsubscribe();
	}
}
